import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "mmedia_admin_token";

export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}
export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export async function submitLead(payload) {
  const res = await axios.post(`${API}/leads`, payload);
  return res.data;
}
export async function subscribeNewsletter(email) {
  const res = await axios.post(`${API}/newsletter`, { email });
  return res.data;
}
export async function adminLogin(email, password) {
  const res = await axios.post(`${API}/admin/login`, { email, password });
  return res.data;
}
export async function fetchLeads() {
  const res = await api.get("/admin/leads");
  return res.data;
}
export async function updateLeadStatus(id, status) {
  const res = await api.patch(`/admin/leads/${id}`, { status });
  return res.data;
}
export async function deleteLead(id) {
  await api.delete(`/admin/leads/${id}`);
}
export async function fetchStats() {
  const res = await api.get("/admin/stats");
  return res.data;
}
export async function adminMe() {
  const res = await api.get("/admin/me");
  return res.data;
}
